import * as React from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

export default function StripePaymentSection({ onReady }) {
  const [loading, setLoading] = React.useState(true);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom align="left" fontSize="15px">
        Payment details
      </Typography>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
          <CircularProgress size={28} />
        </Box>
      )}

      <Box sx={{ display: loading ? "none" : "block" }}>
        <PaymentElement
          onReady={() => {
            setLoading(false);
            if (onReady) onReady();
          }}
        />
      </Box>
    </Box>
  );
}